import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Modal from '../../../../components/Modal';
import './index.scss'

export default function ModalInfo(props) {
  const { showModal, onHide, children, className = '', hideBottom = false, ...restProps } = props;
  const [isShowModal, setShowModal] = useState(showModal);

  useEffect(() => {
    // console.log('showModal changed....', showModal);
    setShowModal(showModal);
  }, [showModal]);

  const hideModal = () => {
    setShowModal(false);
  }

  return ReactDOM.createPortal(
    <Modal
      className={`${className} modal-info-wrapper`}
      isOpened={isShowModal}
      onHide={onHide}
      position='bottom'
      {
        ...restProps
      }
    >
      {
        children
      }
      {!hideBottom && <div className="action-field">
        <div className="confirm-btn" onClick={hideModal}>确定</div>
      </div>}
    </Modal>,
    document.body,
  );
}
